export default {"src":"/_next/static/media/reporting.4b86ab11.svg","height":398,"width":400};